import { createContext } from 'react';

export const initialState = {
    active: null,
    profile: null,
};

export const ConfCuponsStateContext = createContext(initialState);
export const ConfCuponsDispatchContext = createContext();
